export default "__VITE_ASSET__QFf9i1LB__"